import React from "react";
import {
  FaBalanceScale,
  FaBuilding,
  FaChartLine,
  FaCheck,
  FaClipboardCheck,
  FaCogs,
  FaCreditCard,
  FaFileAlt,
  FaGavel,
  FaIndustry,
  FaShieldAlt,
  FaTruck,
  FaUserCheck,
  FaUserTie,
  FaWarehouse,
} from "react-icons/fa";

const CLIP_TITLES = {
  default: "TERMS & CONDITIONS",
  platform: "OVERALL PLATFORM",
  auction: "AUCTION TERMS",
  infrastructure: "INFRASTRUCTURE LEASING",
  manufacturing: "CONTRACT MANUFACTURING",
  p2p: "PROCURE-TO-PAY",
  quality: "QUALITY ASSESSMENT",
  consultants: "CONSULTANTS",
  legal: "LEGAL PROFESSIONALS",
  logistics: "LOGISTICS MODULE",
};

/** Decorative hero graphic for Terms pages (module-specific variants). */
export default function TermsHeroVisual({ variant = "default" }) {
  const isPlatform = variant === "platform";
  const isAuction = variant === "auction";
  const isInfrastructure = variant === "infrastructure";
  const isManufacturing = variant === "manufacturing";
  const isP2p = variant === "p2p";
  const isQuality = variant === "quality";
  const isConsultants = variant === "consultants";
  const isLegal = variant === "legal";
  const isLogistics = variant === "logistics";
  const clipTitle = CLIP_TITLES[variant] || CLIP_TITLES.default;
  const visualClass = [
    "hub-terms-hero__visual",
    isPlatform && "hub-terms-hero__visual--platform",
    isAuction && "hub-terms-hero__visual--auction",
    isInfrastructure && "hub-terms-hero__visual--infrastructure",
    isManufacturing && "hub-terms-hero__visual--manufacturing",
    isP2p && "hub-terms-hero__visual--p2p",
    isQuality && "hub-terms-hero__visual--quality",
    isConsultants && "hub-terms-hero__visual--consultants",
    isLegal && "hub-terms-hero__visual--legal",
    isLogistics && "hub-terms-hero__visual--logistics",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={visualClass} aria-hidden>
      {isPlatform ? (
        <div className="hub-terms-hero__badge-wrap">
          <span className="hub-terms-hero__badge hub-terms-hero__badge--navy">
            <FaBuilding />
          </span>
          <span className="hub-terms-hero__badge hub-terms-hero__badge--orange hub-terms-hero__badge--offset">
            <FaShieldAlt />
          </span>
        </div>
      ) : null}

      {isAuction ? (
        <div className="hub-terms-hero__badge-wrap">
          <span className="hub-terms-hero__badge hub-terms-hero__badge--navy">
            <FaGavel />
          </span>
          <span className="hub-terms-hero__badge hub-terms-hero__badge--orange hub-terms-hero__badge--offset">
            <FaFileAlt />
          </span>
        </div>
      ) : null}

      {isInfrastructure ? (
        <div className="hub-terms-hero__badge-wrap">
          <span className="hub-terms-hero__badge hub-terms-hero__badge--navy">
            <FaBuilding />
          </span>
          <span className="hub-terms-hero__badge hub-terms-hero__badge--orange hub-terms-hero__badge--offset">
            <FaIndustry />
          </span>
        </div>
      ) : null}

      {isManufacturing ? (
        <div className="hub-terms-hero__badge-wrap">
          <span className="hub-terms-hero__badge hub-terms-hero__badge--navy">
            <FaIndustry />
          </span>
          <span className="hub-terms-hero__badge hub-terms-hero__badge--orange hub-terms-hero__badge--offset">
            <FaCogs />
          </span>
        </div>
      ) : null}

      {isP2p ? (
        <div className="hub-terms-hero__badge-wrap">
          <span className="hub-terms-hero__badge hub-terms-hero__badge--navy">
            <FaFileAlt />
          </span>
          <span className="hub-terms-hero__badge hub-terms-hero__badge--orange hub-terms-hero__badge--offset">
            <FaCreditCard />
          </span>
        </div>
      ) : null}

      {isQuality ? (
        <div className="hub-terms-hero__badge-wrap">
          <span className="hub-terms-hero__badge hub-terms-hero__badge--navy">
            <FaClipboardCheck />
          </span>
          <span className="hub-terms-hero__badge hub-terms-hero__badge--orange hub-terms-hero__badge--offset">
            <FaUserCheck />
          </span>
        </div>
      ) : null}

      {isConsultants ? (
        <div className="hub-terms-hero__badge-wrap">
          <span className="hub-terms-hero__badge hub-terms-hero__badge--navy">
            <FaUserTie />
          </span>
          <span className="hub-terms-hero__badge hub-terms-hero__badge--orange hub-terms-hero__badge--offset">
            <FaChartLine />
          </span>
        </div>
      ) : null}

      {isLegal ? (
        <div className="hub-terms-hero__badge-wrap">
          <span className="hub-terms-hero__badge hub-terms-hero__badge--navy">
            <FaBalanceScale />
          </span>
          <span className="hub-terms-hero__badge hub-terms-hero__badge--orange hub-terms-hero__badge--offset">
            <FaGavel />
          </span>
        </div>
      ) : null}

      {isLogistics ? (
        <div className="hub-terms-hero__badge-wrap">
          <span className="hub-terms-hero__badge hub-terms-hero__badge--orange">
            <FaTruck />
          </span>
          <span className="hub-terms-hero__badge hub-terms-hero__badge--navy hub-terms-hero__badge--offset">
            <FaWarehouse />
          </span>
        </div>
      ) : null}

      <div className="hub-terms-hero__clip">
        <div className="hub-terms-hero__clip-top" />
        <div className="hub-terms-hero__clip-board">
          <span className="hub-terms-hero__clip-title">{clipTitle}</span>
          <span className="hub-terms-hero__clip-line" />
          <span className="hub-terms-hero__clip-line hub-terms-hero__clip-line--short" />
          <span className="hub-terms-hero__clip-line" />
          <span className="hub-terms-hero__clip-checks">
            <span className="hub-terms-hero__clip-check">
              <FaCheck />
            </span>
            <span className="hub-terms-hero__clip-check">
              <FaCheck />
            </span>
            <span className="hub-terms-hero__clip-check">
              <FaCheck />
            </span>
          </span>
        </div>
      </div>

      <div className="hub-terms-hero__shield">
        <FaShieldAlt />
        <FaCheck className="hub-terms-hero__shield-check" />
      </div>
    </div>
  );
}
